module.exports = __webpack_public_path__ + "static/overview-tavla-069ae3641799ddaf2fee6ea0d1d9cd58.svg";